

// // components/CustomTitle.js
// import { Helmet } from "react-helmet";

// const CustomTitle = ({ title }) => (
//    <Helmet>
//       <title>{title} | موقع محمود</title>
//    </Helmet>
// );



import React from 'react'
import { Helmet } from 'react-helmet'

export default function CustomTitle({title}) {
   return (
      <Helmet>
         <title> TREND  |  {title}</title>
      </Helmet>
   )
}
